const header = document.querySelector(".js-header");
const openCatBtns = header.querySelectorAll(".js-open-cat");
const catDivs = header.querySelectorAll(".js-cat");
// const overlayDiv    = document.querySelector(".js-overlay");
const scrollUp = "is-scroll-up";
const scrollDown = "is-scroll-down";
let lastScroll = 0; 

/*
 *
 * On scroll down, header disappear
 * On scroll up, header appear
 *
 */

window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll <= 1) {
        header.classList.remove(scrollUp);
        return;
    }

    if (currentScroll > lastScroll && !header.classList.contains(scrollDown)) {
        // down
        header.classList.remove(scrollUp);
        header.classList.add(scrollDown);
        closeCat();
        closeBurger();
        closeSearch();
    } else if (
        currentScroll < lastScroll &&
        header.classList.contains(scrollDown)
    ) {
        // up
        header.classList.remove(scrollDown);
        header.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
});

/*
 *
 * On click, open section
 *
 */
openCatBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
        //e.preventDefault();
        var toOpen = btn.dataset.cat;
        if ($(".js-cat-" + toOpen).length) {
            e.preventDefault();
            if (btn.classList.contains("is-active")) {
                closeCat();
            } else {
                if (burgerDiv.classList.contains("is-active")) {
                    closeBurger();
                }
                closeSearch();
                openCat(btn);
            }
        }
    });
});

function closeCat() {
    openCatBtns.forEach((btn) => {
        btn.classList.remove("is-active");
        btn.classList.remove("is-disable");
    });
    catDivs.forEach((section) => {
        section.classList.remove("is-active");
    });
    overlayDiv.classList.remove("is-active");
}

function openCat(btn) {
    openCatBtns.forEach((_btn) => {
        _btn.classList.remove("is-active");
        _btn.classList.add("is-disable");
    });
    catDivs.forEach((section) => {
        section.classList.remove("is-active");
    });
    btn.classList.remove("is-disable");
    btn.classList.add("is-active");
    overlayDiv.classList.add("is-active");
    const cat = btn.dataset.cat;
    const divCat = document.querySelector(".js-cat-" + cat);
    divCat.classList.add("is-active");
    // on ajoute le contenu des 3 derniers articles en ajax
    load_nav_menu_3_last_posts(btn.dataset.tid, btn.dataset.ttype, btn);
}

function openSearch() {
    const searchPreviewResult = header.querySelector(".js-search");

    if (burgerDiv.classList.contains("is-active")) {
        closeBurger();
    }
    closeCat();

    searchPreviewResult.classList.add("is-active");
    overlayDiv.classList.add("is-active");
}

function closeSearch() {
    const searchContainer = document.querySelector(".js-search-container");
    const searchPreviewResult = header.querySelector(".js-search");

    searchPreviewResult.classList.remove("is-active");
    overlayDiv.classList.remove("is-active");
    searchContainer.classList.remove("is-open");
}

// header.addEventListener('mouseleave', ()=>{
//     if(searchContainer.classList.contains('is-open')){
//         searchContainer.classList.remove('is-open');
//         closeSearch();
//     }
// })


function load_nav_menu_3_last_posts(tid, ttype, btn){
    //if( $('.js-submenu-articles-tid-'+tid).is(':empty') ){
    if( $('.js-submenu-articles-tid-'+tid).hasClass('loading') ){
        $.ajax({
            url: wami_js.ajaxurl,
            data: {
                action: "wami_load_nav_menu_3_last_posts",
                tid: tid,
                ttype: ttype,
            },
            success: function (data) {
                var obj = jQuery.parseJSON(data);
                //console.log(obj.content);
                $('.js-submenu-articles-tid-'+tid).html(obj.content);
                $('.js-submenu-articles-tid-'+tid).removeClass('loading');
                
            },
            error: function (errorThrown) {
                console.log("erreur de chargement menu");
            },
        });
    }
}
